import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderCountModel } from '../../../../models/order-count.model';
import { CONSTANTS } from '../../../../constants';
import { PoTagModule, PoTagType, PoWidgetModule } from '@po-ui/ng-components';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-order-count-list',
  imports: [PoWidgetModule, PoTagModule, CommonModule],
  templateUrl: './order-count-list.component.html',
  styleUrl: './order-count-list.component.css'
})
export class OrderCountListComponent {
  @Input() counts: OrderCountModel[] = [];
  @Output() orderCountSelected = new EventEmitter<OrderCountModel>();
  statusLabels = CONSTANTS.COUNT_STATUS;
  colorsStatusLabels = CONSTANTS.COUNT_STATUS_COLORS;

  orderCountClicked(item: OrderCountModel) {
    this.orderCountSelected.emit(item);
  }

  getStatusColor(value: number): PoTagType {
    return CONSTANTS.COUNT_STATUS_COLORS[value as keyof typeof CONSTANTS.COUNT_STATUS_COLORS] ?? PoTagType.Neutral;
  }
}
